import {
  Avatar,
  NavigationProfile,
  Row,
  Tooltip,
  Typography,
  getFirstLetterInName,
  neutral,
  neutralTrans,
} from 'enable-ui';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';

import { Container } from '../styles/menu-footer';

import { getUserColor } from 'helpers';
import { useBoolean } from 'hooks';

import { PopoverUserProfile } from './PopoverUserProfile';

export const MenuFooter = ({ delay }: { delay: boolean }) => {
  const userProfile = useAuthStore(userProfileSelector);
  const visible = useBoolean(false);
  const avatarURL = userProfile?.physicalProfile?.avatar || '';
  const avatarConfig = {
    bg: avatarURL ? 'transparent' : getUserColor(userProfile?.name),
    border: `1px solid ${avatarURL ? 'transparent' : neutralTrans['neutralTrans-20']}`,
    color: neutral['neutral-1'],
  };

  return (
    <Container style={{ padding: '6px 0 22px 0' }}>
      <div className={delay ? '' : 'wrap-profile'}>
        <NavigationProfile
          content={
            <Tooltip
              bg="transparent"
              trigger="click"
              arrow={false}
              placement="right-end"
              content={<PopoverUserProfile setVisible={visible.setValue} />}
              visible={visible.value}
              offset={[5, 25]}
              allowHTML
              interactive
              onClickOutside={() => visible.setValue(false)}
            >
              <Row
                align="center"
                onClick={() => visible.setValue((prev) => !prev)}
                style={{
                  padding: '0px 12px',
                }}
              >
                <Avatar
                  items={{
                    label: getFirstLetterInName(userProfile?.name, true),
                    src: avatarURL,
                  }}
                  size="small"
                  config={avatarConfig}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
                {delay && (
                  <Row direction="column" style={{ marginLeft: 12 }}>
                    <Typography
                      className="text-ellipsis-1"
                      weight={500}
                      color={neutral['neutral-11']}
                      style={{
                        textAlign: 'start',
                        fontSize: '18px',
                        lineHeight: '26px',
                        maxWidth: '156px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {userProfile?.name}
                    </Typography>
                    <Typography weight={400} color={neutral['neutral-7']} style={{ fontSize: 13 }}>
                      {userProfile?.institution?.name}
                    </Typography>
                  </Row>
                )}
              </Row>
            </Tooltip>
          }
        />
      </div>
    </Container>
  );
};
